import React, { Fragment, useRef, useState } from 'react';
import { Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useClickAway } from 'react-use';
import { getRequest, postRequest } from '../../../utils/axiosRequests';
import CommonButtons from '../partials/commonButtons';

const generateRange = (start, end, step) => {
  const values = [];
  for (let i = start; Math.round(i * 100) <= Math.round(end * 100); i += step) {
    values.push(Math.round(i * 100) / 100);
  }
  return values;
};

const formatPickerLabel = (val) => {
  const sign = val > 0 ? '+' : '';
  return `${sign}${parseFloat(val).toFixed(2)}`;
};

const PICKER_CONFIGS = {
  sph: {
    positive: ['Plano', ...generateRange(0.25, 10, 0.25)],
    negative: generateRange(0.25, 10, 0.25).map((v) => -v),
    hasTabs: true,
  },
  cyl: {
    positive: ['Plano', ...generateRange(0.25, 10, 0.25)],
    negative: generateRange(0.25, 10, 0.25).map((v) => -v),
    hasTabs: true,
  },
  axis: {
    positive: ['005','015','030','035','045','060','075','090','105','115','165','180'],
    hasTabs: false,
  },
  add: {
    positive: [...generateRange(0.25, 3.5, 0.25)],
    hasTabs: false,
  },
};

const EyeGlassButtonPicker = ({ fieldName, onSelect, onClose }) => {
  const [pickerTab, setPickerTab] = React.useState('positive');
  const config = PICKER_CONFIGS[fieldName] || PICKER_CONFIGS.sph;
  const values = pickerTab === 'positive' ? config.positive : config.negative;

  return (
    <div className="eye-glass-picker">
      <div className="picker-header">
        {config.hasTabs && (
          <div className="picker-tabs">
            <span
              className={pickerTab === 'positive' ? 'active' : ''}
              onClick={() => setPickerTab('positive')}
            >
              Positive
            </span>
            <span
              className={pickerTab === 'negative' ? 'active' : ''}
              onClick={() => setPickerTab('negative')}
            >
              Negative
            </span>
          </div>
        )}
        <span className="picker-close" onClick={onClose}>
          ×
        </span>
      </div>
      <div className="picker-grid">
        {values.map((val, i) => {
          const label = typeof val === 'string' ? val : formatPickerLabel(val);
          return (
            <button
              key={i}
              className="picker-btn"
              onClick={() => onSelect(label)}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};


const EyeGlass = ({
  modalTitle,
  showEyeGlass,
  setShowEyeGlass,
  selectedEyeGlass,
  setSelectedEyeGlass,
  deletePrescriptionItem,
}) => {
  let { isPlano, leftPlano, rightPlano, add, lens, pd, r, l, remarks } =
    selectedEyeGlass;
  const [isRBtn, setIsRBtn] = useState(false);
  const [isLBtn, setIsLBtn] = useState('');
  // const [domainVal, setDomainVal] = useState([]);
  const [isRSph, setIsRSph] = useState(false);
  const [isRCyl, setIsRCyl] = useState(false);
  const [isRAxis, setIsRAxis] = useState(false);
  const [isLSph, setIsLSph] = useState(false);
  const [isLCyl, setIsLCyl] = useState(false);
  const [isLAxis, setIsLAxis] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [allRemarks, setAllRemarks] = useState([]);
  const [isRemarksOpen, setIsRemarksOpen] = useState(false);
  const [lensInput, setLensInput] = useState('');
  const [isGlassOpen, setIsGlassOpen] = useState(false);
  // const tickCount = 10;
  const angleButtonArray = [
    '6/6',
    '6/9',
    '6/12',
    '6/18',
    '6/24',
    '6/36',
    '6/60',
    '5/60',
    '4/60',
    '3/60',
    '2/60',
    '1/60',
    "CF1'","CF2'","CF3'","CF4'","CF5'","HM1'","HM2'","HM3'","NPL"
  ];
  const glassOptions = [
    { name: 'White Verilux' },
    { name: 'Light Potosn Unifocal' },
    { name: 'White Bifocal' },
    { name: 'White Unifocal' },
    { name: 'Antireflecting Unifocal' },
    { name: 'Antireflecting Verilux' },
  ];

  const handleData = (rowName, fieldName, value, vaVal, actionType) => {
    if (fieldName === 'isPlano') {
      selectedEyeGlass.r = { sph: '', cyl: '', axis: '' };
      selectedEyeGlass.l = { sph: '', cyl: '', axis: '' };
      selectedEyeGlass.add = '';
      selectedEyeGlass.lens = '';
      selectedEyeGlass.pd = '';
      selectedEyeGlass[fieldName] = value;
    } else if (rowName) {
      selectedEyeGlass[rowName][fieldName] = vaVal ? vaVal : value;
      setIsLBtn(false);
      setIsRBtn(false);
    } else {
      selectedEyeGlass[fieldName] = value;
    }
    setSelectedEyeGlass({ ...selectedEyeGlass });
    if (actionType === 'click') {
      clearSlider();
    }
    setSelectedEyeGlass({ ...selectedEyeGlass });
  };

  const clearSlider = () => {
    setIsAdd(false);
    setIsRSph(false);
    setIsRCyl(false);
    setIsRAxis(false);
    setIsLSph(false);
    setIsLCyl(false);
    setIsLAxis(false);
  };

  const handleSlider = (rowName, name) => {
    clearSlider();
    setIsRBtn(false);
    setIsLBtn(false);

    if (rowName === 'r') {
      if (name === 'sph') {
        // setDomainVal([-20, 20]);
        setIsRSph(true);
      } else if (name === 'cyl') {
        // setDomainVal([-5, 5]);
        setIsRCyl(true);
      } else if (name === 'axis') {
        // setDomainVal([0, 180]);
        setIsRAxis(true);
      }
    } else {
      if (name === 'sph') {
        // setDomainVal([-20, 20]);
        setIsLSph(true);
      } else if (name === 'cyl') {
        // setDomainVal([-5, 5]);
        setIsLCyl(true);
      } else if (name === 'axis') {
        // setDomainVal([0, 180]);
        setIsLAxis(true);
      }
    }
  };

  const getRemarks = async (searchKey) => {
    try {
      const res = await getRequest(`eyeglass-remarks?searchKey=${searchKey}`);
      setAllRemarks(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const createNewItem = async (newItem) => {
    await postRequest('eyeglass-remarks', { name: newItem })
      .then((data) => {
        selectedEyeGlass?.remarks?.push(newItem);
        setSelectedEyeGlass({ ...selectedEyeGlass });
      })
      .catch((error) => {
        console.log(error);
      });
    typeaheadRef.current.clear();
  };

  const typeaheadRef = useRef(null);
  const glassTypeaheadRef = useRef(null);
  const selectItem = (selectedOption) => {
    const selectedData = selectedOption[0].name;
    if (!selectedEyeGlass?.remarks.some((remark) => remark === selectedData)) {
      selectedEyeGlass?.remarks?.push(selectedData);
      setSelectedEyeGlass({ ...selectedEyeGlass });
    }
    typeaheadRef.current.clear();
  };

  const ref = useRef(null);
  useClickAway(ref, (e) => {
    const clickedArea = e.target;
    if (!clickedArea.classList.contains('glass-slider-area')) {
      setIsAdd(false);
      setIsRSph(false);
      setIsRCyl(false);
      setIsRAxis(false);
      setIsLSph(false);
      setIsLCyl(false);
      setIsLAxis(false);
    }
  });

  const refVa = useRef(null);
  // useClickAway(refVa, (e) => {
  //   const clickedArea = e.target;

  //   console.log(99911);

  //   if (!clickedArea.classList.contains('rl-va')) {
  //     setIsRBtn(false);
  //     setIsLBtn(false);
  //   }
  // });

  return (
    <Modal
      show={showEyeGlass}
      size="lg"
      className="customize-modal-size eye-glass-modal glass-table"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Modal.Body style={{ background: '#F8F8F8' }}>
        <style>{`
          .glass-slider-area {
            position: absolute;
            z-index: 100;
            height: auto !important;
            width: 380px;
            top: 80px;
            padding: 12px 14px;
          }
          .eye-glass-picker .picker-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
          }
          .eye-glass-picker .picker-tabs {
            display: flex;
            gap: 14px;
          }
          .eye-glass-picker .picker-tabs span {
            cursor: pointer;
            font-size: 13px;
            color: #888;
            padding-bottom: 2px;
          }
          .eye-glass-picker .picker-tabs span.active {
            color: #1a9b8a;
            font-weight: 600;
            border-bottom: 2px solid #1a9b8a;
          }
          .eye-glass-picker .picker-close {
            cursor: pointer;
            font-size: 20px;
            color: #666;
            line-height: 1;
          }
          .eye-glass-picker .picker-close:hover { color: #333; }
          .eye-glass-picker .picker-grid {
            display: flex;
            flex-wrap: wrap;
            gap: 5px;
          }
          .eye-glass-picker .picker-btn {
            background: #1a9b8a;
            color: #ffffff;
            border: none;
            border-radius: 4px;
            padding: 4px 8px;
            font-size: 12px;
            cursor: pointer;
            min-width: 52px;
          }
          .eye-glass-picker .picker-btn:hover { background: #157a6e; }
        `}</style>
        <div className="eye-glass-title">
          <span>{modalTitle}</span>
          <span onClick={() => setShowEyeGlass(false)}>
            <i className="fa fa-times-circle" />
          </span>
        </div>
        <hr style={{ marginTop: '0.3rem', marginBottom: '0.3rem' }} />
        <Row className="pt-1 pb-2">
          <Col>
            <Form.Check
              type={`checkbox`}
              id={`query`}
              label={`Plano`}
              checked={isPlano}
              onChange={(e) => handleData('', 'isPlano', e.target.checked)}
            />
          </Col>
          <Col>
            <Form.Check
              type={`checkbox`}
              id={`query`}
              label={`Right Plano`}
              checked={rightPlano}
              onChange={(e) => handleData('', 'rightPlano', e.target.checked)}
            />
          </Col>
          <Col>
            <Form.Check
              type={`checkbox`}
              id={`query`}
              label={`Left Plano`}
              checked={leftPlano}
              onChange={(e) => handleData('', 'leftPlano', e.target.checked)}
            />
          </Col>
        </Row>
        <Row style={{ position: 'relative' }}>
          <Col>
            <Table>
              <thead>
                <tr>
                  <th colSpan={2} width="18%">
                    -
                  </th>
                  <th>SPH(D)</th>
                  <th>CYL(D)</th>
                  <th>Axis(°)</th>
                  <th style={{ width: '20%' }}>V/A</th>
                </tr>
              </thead>
              <tbody style={{ position: 'relative' }}>
                <tr>
                  <td rowSpan={2}>DIST</td>
                  <td>R</td>
                  {isPlano || rightPlano ? (
                    <>
                      <td colSpan={3}>
                        <b>Plano</b>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>
                        <Form.Control
                          size="sm"
                          type="text"
                          value={r?.sph||''}
                          onClick={() => handleSlider('r', 'sph')}
                          onChange={(e) =>
                            handleData('r', 'sph', e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          size="sm"
                          type="text"
                          value={r?.cyl||''}
                          onClick={() => handleSlider('r', 'cyl')}
                          onChange={(e) =>
                            handleData('r', 'cyl', e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          size="sm"
                          type="text"
                          value={r?.axis||''}
                          onClick={() => handleSlider('r', 'axis')}
                          onChange={(e) =>
                            handleData('r', 'axis', e.target.value)
                          }
                        />
                      </td>
                    </>
                  )}
                  <td ref={refVa}>
                    <Form.Control
                      size="sm"
                      type="text"
                      className="rl-va"
                      value={r?.v_a||''}
                      onClick={() => {
                        setIsRBtn(isRBtn ? false : true);
                        setIsLBtn(false);
                        clearSlider();
                      }}
                      onChange={(e) => handleData('r', 'v_a', e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>L</td>
                  {isPlano || leftPlano ? (
                    <>
                      <td colSpan={3}>
                        <b>Plano</b>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>
                        <Form.Control
                          size="sm"
                          type="text"
                          value={l?.sph||''}
                          onClick={() => handleSlider('l', 'sph')}
                          onChange={(e) =>
                            handleData('l', 'sph', e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          size="sm"
                          type="text"
                          value={l?.cyl||''}
                          onClick={() => handleSlider('l', 'cyl')}
                          onChange={(e) =>
                            handleData('l', 'cyl', e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          size="sm"
                          type="text"
                          value={l?.axis||''}
                          onClick={() => handleSlider('l', 'axis')}
                          onChange={(e) =>
                            handleData('l', 'axis', e.target.value)
                          }
                        />
                      </td>
                    </>
                  )}
                  <td ref={refVa}>
                    <Form.Control
                      size="sm"
                      type="text"
                      className="rl-va"
                      value={l?.v_a||''}
                      onClick={() => {
                        setIsLBtn(isLBtn ? false : true);
                        setIsRBtn(false);
                        clearSlider();
                      }}
                      onChange={(e) => handleData('l', 'v_a', e.target.value)}
                    />
                  </td>
                </tr>
                {isRBtn && (
                  <CommonButtons
                    unitArray={angleButtonArray}
                    clickAction={handleData}
                    rowName="r"
                    colName="v_a"
                    indexName="r-va-btn"
                  />
                )}
                {isLBtn && (
                  <CommonButtons
                    unitArray={angleButtonArray}
                    clickAction={handleData}
                    rowName="l"
                    colName="v_a"
                    indexName="l-va-btn"
                  />
                )}
              </tbody>
            </Table>

            {isRSph && (
              <div ref={ref} className="glass-slider-area rsph">
                <EyeGlassButtonPicker
                  fieldName="sph"
                  onSelect={(value) => handleData('r', 'sph', value, '', 'click')}
                  onClose={clearSlider}
                />
              </div>
            )}
            {isRCyl && (
              <div ref={ref} className="glass-slider-area rcyl">
                <EyeGlassButtonPicker
                  fieldName="cyl"
                  onSelect={(value) => handleData('r', 'cyl', value, '', 'click')}
                  onClose={clearSlider}
                />
              </div>
            )}
            {isRAxis && (
              <div ref={ref} className="glass-slider-area raxis">
                <EyeGlassButtonPicker
                  fieldName="axis"
                  onSelect={(value) => handleData('r', 'axis', value, '', 'click')}
                  onClose={clearSlider}
                />
              </div>
            )}
            {isLSph && (
              <div ref={ref} className="glass-slider-area lsph">
                <EyeGlassButtonPicker
                  fieldName="sph"
                  onSelect={(value) => handleData('l', 'sph', value, '', 'click')}
                  onClose={clearSlider}
                />
              </div>
            )}
            {isLCyl && (
              <div ref={ref} className="glass-slider-area lcyl">
                <EyeGlassButtonPicker
                  fieldName="cyl"
                  onSelect={(value) => handleData('l', 'cyl', value, '', 'click')}
                  onClose={clearSlider}
                />
              </div>
            )}
            {isLAxis && (
              <div ref={ref} className="glass-slider-area laxis">
                <EyeGlassButtonPicker
                  fieldName="axis"
                  onSelect={(value) => handleData('l', 'axis', value, '', 'click')}
                  onClose={clearSlider}
                />
              </div>
            )}
          </Col>
        </Row>
        <Row className="pt-1 pb-2" style={{ position: 'relative' }}>
          <Col className="eye-glass-bottom pr-0" md={4} sm={4} xs={4}>
            <div>Add:</div>
            <Form.Control
              size="sm"
              disabled={isPlano}
              type="text"
              value={add||''}
              onChange={(e) => handleData('', 'add', e.target.value)}
              onClick={() => {
                clearSlider();
                setIsAdd(isAdd ? false : true);
              }}
            />{' '}
            <div>&nbsp;D</div>
          </Col>
          <Col className="eye-glass-bottom" md={3} sm={4} xs={4}>
            <div>IPD:</div>
            <Form.Control
              size="sm"
              disabled={isPlano}
              type="text"
              defaultValue={pd}
              onChange={(e) => handleData('', 'pd', e.target.value)}
            />
            <div>&nbsp;mm</div>
          </Col>
          <Col lg={5} md={8} sm={8} xs={10} className="eye-glass-bottom ">
          
            <div>Glass:</div>{' '}
            <div style={{ position: 'relative', width: '100%' }}>
            
            <Typeahead
                //className="glass-typeahead"
                containerClassName="position-relative w-100"
                style={{ width: '100%',paddingRight: '50px' }} 
                labelKey="name"
                ref={glassTypeaheadRef}
                id="glass-typeahead"
                options={glassOptions}
                placeholder="Select Eye Glass Type"
                allowNew
                newSelectionPrefix="Click to Select new: "
                //clearButton
                size="sm"
                
                open={isGlassOpen}   // 👈 control dropdown

                onFocus={() => setIsGlassOpen(true)}   // open on focus

                // onMenuToggle={(isOpen) => {
                //   setIsGlassOpen(isOpen);
                // }} 
               

                onBlur={() => setIsGlassOpen(false)}   // close when leaving
                // FINAL selection only
                onChange={(selected) => {
                  if (!selected.length) {
                    handleData('', 'lens', '');
                    setLensInput('');
                    return;
                  }

                  const item = selected[0];

                  const value = item?.name || item?.label || item;

                  handleData('', 'lens', value);
                  setLensInput(value);
                  glassTypeaheadRef.current.clear();

                  setIsGlassOpen(false);
                  glassTypeaheadRef.current.blur();
                  
                  setLensInput('');
                }}

                
                // onInputChange={(text) => {
                //   setLensInput(text);
  
                // }}

                // controlled selection (ONLY final value)
                //selected={lens ? [{ name: lens }] : []}

                // optional: show typing value stability
                //inputValue={lensInput}
              />
            
              </div>
          </Col>
          {isAdd && (
            <div className="glass-slider-area add-slider">
              <EyeGlassButtonPicker
                fieldName="add"
                onSelect={(value) => handleData('', 'add', value, '', 'click')}
                onClose={clearSlider}
              />
            </div>
          )}
        </Row>

        <Row className="pt-2 pb-2">
          <Col lg={6} md={8} sm={8} xs={10} className="eye-glass-bottom pr-0">
            <div>Remarks:</div>
            <Typeahead
              style={{ width: '83%' }}
              allowNew
              labelKey="name"
              ref={typeaheadRef}
              id="custom-selections-example"
              newSelectionPrefix="Click to add new: "
              options={allRemarks}
              placeholder="Search / Add remarks here ..."

              open={isRemarksOpen}   // 👈 control dropdown

              onFocus={() => setIsRemarksOpen(true)}
              
              onBlur={() => setIsRemarksOpen(false)}   // close when leaving

              onInputChange={(text) => {
                getRemarks(text);
              }}
              onChange={(selected) => {
                const isNewSelection =
                  selected.length && selected[0].customOption;
                if (isNewSelection) {
                  createNewItem(selected[0].name);
                } else {
                  selectItem(selected);
                }
                typeaheadRef.current.clear();
                typeaheadRef.current.blur();
                setIsRemarksOpen(false);
              }}
              size="sm"
              renderMenuItemChildren={(option, props) => (
                <Fragment>
                  <span>{option.name}</span>
                </Fragment>
              )}
            />
          </Col>
          {lens && (
            <div
              style={{
                marginLeft: "5.5rem",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span style={{ color: '#6e707e' }}>
                Selected Glass: {selectedEyeGlass.lens}
              </span>

              <span
                className="cursor-pointer"
                onClick={() => {
                  handleData('', 'lens', '');   // clear value
                  setLensInput('');             // clear input box
                  glassTypeaheadRef.current?.clear(); // clear typeahead UI
                }}
              >
                <i
                  className="fa fa-times-circle"
                  style={{ color: '#CB2020D9' }}
                ></i>
              </span>
            </div>
          )}
        </Row>
        {remarks?.length > 0 && (
          <Row>
            <Col lg={6} md={8} sm={8} xs={8}>
              <div className="eye-glass-remarks">
                {remarks.map((remark, index) => {
                  return (
                    <div key={index}>
                      <span className="text-left" style={{ color: '#6e707e' }}>
                        {remark}
                      </span>
                      <span
                        className="float-right cursor-pointer"
                        onClick={() =>
                          deletePrescriptionItem('eyeGlassRemark', remark)
                        }
                      >
                        <i
                          className="fa fa-times-circle"
                          style={{ color: '#CB2020D9' }}
                        ></i>
                      </span>
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default EyeGlass;
